module.exports = __webpack_public_path__ + "static/media/products.565d9553.svg";